module.exports = __webpack_public_path__ + "static/media/icon-bus.bdbb417a.svg";